export default {
  AppLayout: {
    anonymous: 'Anonymous',
    Menu: {
      mortgageInfo: 'Mortgage Info',
      dashboard: 'Dashboard',
      messages: 'Messages',
      calculators: 'Calculators',
      account: 'Account',
      logout: 'Logout',
      connections: 'Connections',
      settings: 'Settings',
      findRealEstateAgents: 'Find Agents',
    },
  },
  NonAuthLayout: {
    Menu: {
      freeQuotes: 'Mortgage Rates',
      resources: 'Resources',
      login: 'Log in',
      calculators: 'Calculators',
      budget: 'Home Price Budget',
      DesktopMenu: {
        anonymous: 'Anonymous',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en/layouts.js